var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-navbar-nav",
    { staticClass: "sidebar" },
    [
      _c(
        "b-navbar-brand",
        {
          staticClass: "logo",
          attrs: { id: "popover-brand", "b-link": "", to: "/" },
        },
        [
          _c("img", {
            attrs: {
              src: require("../../../content/images/rizoma_black.svg"),
              alt: "rizoma",
            },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "navbar-version" }, [
            _vm._v(_vm._s(_vm.version)),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sidebar_header mb-3 mt-3" },
        [
          _c("b-link", { attrs: { to: "/", exact: "" } }, [
            _vm._v("Premio SECIHTI"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.hasMoreThanOneAuthority() && _vm.authenticated
        ? _c(
            "div",
            [
              _c(
                "b-nav-item",
                {
                  staticClass: "pointer",
                  attrs: {
                    id: "consulta-menu-admin",
                    to: { name: "SeleccionaRol" },
                    "data-cy": "entity",
                  },
                },
                [
                  _c("b-icon", {
                    staticClass: "mr-2",
                    attrs: { icon: "person-badge" },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "item-text" }, [
                    _vm._v("Selecciona Rol"),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.authenticated &&
      _vm.hasRolSelected &&
      _vm.selectedRole === "ROLE_EXTERNAL_USER"
        ? _c(
            "div",
            [
              _c(
                "b-nav-item",
                {
                  attrs: {
                    id: "postulador-menu",
                    to: { name: "Postulador" },
                    "data-cy": "entity",
                  },
                },
                [
                  _c("b-icon", {
                    staticClass: "mr-2",
                    attrs: { icon: "file-earmark-plus" },
                  }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "item-text",
                    domProps: {
                      textContent: _vm._s(_vm.$t("global.menu.postulador")),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.authenticated &&
      _vm.hasRolSelected &&
      (_vm.selectedRole === "COORDINADOR" ||
        _vm.selectedRole === "ROLE_ADMIN_PREMIOS" ||
        _vm.selectedRole === "VALIDADOR_DOCUMENTAL" ||
        _vm.selectedRole === "CONSULTA")
        ? _c(
            "div",
            [
              _c(
                "b-nav-item",
                {
                  staticClass: "pointer",
                  attrs: {
                    id: "consulta-menu",
                    to: { name: "ConsultaRegistrosAdmin" },
                    "data-cy": "entity",
                  },
                },
                [
                  _c("b-icon", {
                    staticClass: "mr-2",
                    attrs: { icon: "search" },
                  }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "item-text",
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("global.menu.consulta-registros")
                      ),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.authenticated &&
      _vm.hasRolSelected &&
      (_vm.selectedRole === "COORDINADOR" ||
        _vm.selectedRole === "ROLE_ADMIN_PREMIOS")
        ? _c(
            "div",
            [
              _c(
                "b-nav-item",
                {
                  staticClass: "pointer",
                  attrs: {
                    id: "premios-gestion-usuarios-menu",
                    to: { name: "GestionUsuarios" },
                    "data-cy": "entity",
                  },
                },
                [
                  _c("b-icon", {
                    staticClass: "mr-2",
                    attrs: { icon: "people-fill" },
                  }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "item-text",
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("global.menu.premios-gestion-usuarios")
                      ),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.authenticated &&
      _vm.hasRolSelected &&
      (_vm.selectedRole === "COORDINADOR" ||
        _vm.selectedRole === "ROLE_ADMIN_PREMIOS")
        ? _c(
            "div",
            [
              _c(
                "b-nav-item",
                {
                  attrs: {
                    id: "asignacion-evaluadores-menu",
                    to: { name: "AsignacionEvaluadores" },
                    "data-cy": "entity",
                  },
                },
                [
                  _c("b-icon", {
                    staticClass: "mr-2",
                    attrs: { icon: "person-check" },
                  }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "item-text",
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("global.menu.asignacion-evaluadores")
                      ),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.authenticated &&
      _vm.hasRolSelected &&
      (_vm.selectedRole === "EVALUADOR_INDIVIDUAL" ||
        _vm.selectedRole === "PRESIDENTE_COMISION")
        ? _c(
            "div",
            [
              _c(
                "b-nav-item",
                {
                  staticClass: "pointer",
                  attrs: {
                    id: "evaluador-individual-menu",
                    to: { name: "EvaluacionIndividual" },
                    "data-cy": "entity",
                  },
                },
                [
                  _c("b-icon", {
                    staticClass: "mr-2",
                    attrs: { icon: "clipboard-check" },
                  }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "item-text",
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("global.menu.evaluador-individual")
                      ),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.authenticated &&
      _vm.hasRolSelected &&
      (_vm.selectedRole === "EVALUADOR_PLENARIA" ||
        _vm.selectedRole === "PRESIDENTE_COMISION" ||
        _vm.selectedRole === "COORDINADOR" ||
        _vm.selectedRole === "ROLE_ADMIN_PREMIOS")
        ? _c(
            "div",
            [
              _c(
                "b-nav-item",
                {
                  staticClass: "pointer",
                  attrs: {
                    id: "evaluador-plenaria-menu",
                    to: { name: "EvaluacionPlenaria" },
                    "data-cy": "entity",
                  },
                },
                [
                  _c("b-icon", {
                    staticClass: "mr-2",
                    attrs: { icon: "people" },
                  }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "item-text",
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("global.menu.evaluador-plenaria")
                      ),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.authenticated &&
      _vm.hasRolSelected &&
      (_vm.selectedRole === "PRESIDENTE_COMISION" ||
        _vm.selectedRole === "EVALUADOR_INDIVIDUAL")
        ? _c(
            "div",
            [
              _c(
                "b-nav-item",
                {
                  staticClass: "pointer",
                  attrs: {
                    id: "constancias-evaluador-menu",
                    to: { name: "ConstanciasEvaluador" },
                    "data-cy": "entity",
                  },
                },
                [
                  _c("b-icon", {
                    staticClass: "mr-2",
                    attrs: { icon: "file-text" },
                  }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "item-text",
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("global.menu.constancias-evaluador")
                      ),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.authenticated &&
      _vm.hasRolSelected &&
      (_vm.selectedRole === "COORDINADOR" ||
        _vm.selectedRole === "ROLE_ADMIN_PREMIOS")
        ? _c(
            "div",
            [
              _c(
                "b-nav-item",
                {
                  staticClass: "pointer",
                  attrs: {
                    id: "constancias-menu",
                    to: { name: "constancias" },
                    "data-cy": "entity",
                  },
                },
                [
                  _c("b-icon", {
                    staticClass: "mr-2",
                    attrs: { icon: "file-earmark-text" },
                  }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "item-text",
                    domProps: {
                      textContent: _vm._s(_vm.$t("global.menu.constancias")),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasAnyAuthority("ROLE_ADMIN") && _vm.authenticated
        ? _c(
            "div",
            [
              _c(
                "b-nav-item",
                {
                  directives: [
                    {
                      name: "b-toggle",
                      rawName: "v-b-toggle:collapseAdmin",
                      arg: "collapseAdmin",
                    },
                  ],
                  staticClass: "pointer",
                  class: { "router-link-active": _vm.subIsActive("/admin") },
                  attrs: {
                    id: "admin-menu",
                    "active-class": "active",
                    "data-cy": "adminMenu",
                  },
                },
                [
                  _c("b-icon", { attrs: { icon: "nut" } }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "item-text",
                    domProps: {
                      textContent: _vm._s(_vm.$t("global.menu.admin.main")),
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "ml-auto when-items" }, [
                    _c(
                      "span",
                      { staticClass: "when-open" },
                      [
                        _c("b-icon", {
                          attrs: { icon: "chevron-down", "font-scale": "1.5" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "when-closed" },
                      [
                        _c("b-icon", {
                          attrs: { icon: "chevron-up", "font-scale": "1.5" },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("b-collapse", { attrs: { id: "collapseAdmin" } }, [
                _c(
                  "ul",
                  { staticClass: "list-unstyled subitems" },
                  [_c("admin-menu")],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "b-popover",
                {
                  attrs: {
                    disabled: _vm.popOverDisabled,
                    target: "admin-menu",
                    triggers: "hover",
                    placement: "right",
                    boundaryPadding: "50",
                    boundary: "window",
                  },
                  on: {
                    "update:disabled": function ($event) {
                      _vm.popOverDisabled = $event
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.admin.main")
                                ),
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    1954790522
                  ),
                },
                [
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "list-unstyled subitems subitemsPopover" },
                    [_c("admin-menu")],
                    1
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }